var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"intro"}},[_c('alert-popup',{attrs:{"q":5}}),(_vm.productCategorySelectStyle == '1')?_c('normal-intro',{attrs:{"productDetail":_vm.productDetail}}):_vm._e(),(_vm.productCategorySelectStyle == '2')?_c('business-intro',{attrs:{"productDetail":_vm.productDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }